export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9063.8953f943.jpg";